import { axiosSwagger } from "@/axios";

export const state = {
    duPublic: {
        loading: false,
        data: [],
        total: 0,
    }

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.duPublic.loading = loading;
    },
    setData: (state, data) => {
        state.duPublic.data = data;
    },
    setTotal: (state, total) => {
        state.duPublic.total = total;
    },
    remove: (state, id) => {
        state.duPublic.data = state.duPublic.data.filter((el) => el.id !== id);
    },
}


export const actions = {
    // MY FILE POSTED
    async readDUPublicPosted({ commit }) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Me/Available`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    }
}